/** Query params for GET /roles listing */
export const buildRoleListParams = ({ page = 1, perPage = 10, search = '', guardName = '' } = {}) => ({
  page,
  per_page: perPage,
  paginate: 1,
  ...(search ? { search } : {}),
  ...(guardName ? { 'filters[guard_name]': guardName } : {}),
});

/** Payload for POST/PUT /roles */
export const buildRolePayload = ({ name, guardName, permissionIds = [] }) => ({
  name: (name || '').trim(),
  guard_name: (guardName || '').trim(),
  permissions: permissionIds,
});
